function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgEletronicosECelulares = function SvgEletronicosECelulares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.946.487a2.61 2.61 0 00-3.024 2.117l-.28 1.584-2.37 13.45-.28 1.584a2.609 2.609 0 002.117 3.023l8.31 1.465a2.61 2.61 0 003.022-2.117l2.65-15.033.28-1.585a2.609 2.609 0 00-2.117-3.023L9.946.487zm9.161 5.9l.28-1.585a1.609 1.609 0 00-1.306-1.864L9.77 1.472a1.61 1.61 0 00-1.864 1.306l-.28 1.584 11.48 2.024zM5.257 17.81l11.479 2.024-.28 1.585a1.61 1.61 0 01-1.864 1.306l-8.31-1.465a1.61 1.61 0 01-1.305-1.864l.28-1.586zm11.652 1.04L5.43 16.825l2.025-11.48 11.48 2.025-2.025 11.48zm-6.314 2.25a.704.704 0 10.242-1.386.704.704 0 00-.242 1.386z",
    fill: props.color
  }));
};

SvgEletronicosECelulares.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgEletronicosECelulares.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgEletronicosECelulares;